import { FC } from "react";

export const NewRowIcon: FC<{ columns: number; onClick: () => void }> = ({
  columns,
  onClick,
}) => {
  return (
    <div
      style={{
        width: "calc(100% - 2 * 12px)",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        margin: "14px 12px",
        gap: "10px",
        cursor: "pointer",
      }}
    >
      {new Array(columns).fill(0).map(() => (
        <div
          style={{
            height: columns >= 3 ? "23px" : "33px",
            background: "#5f6068",
            borderRadius: "5px",
            flex: "1 1 100%",
          }}
          onClick={() => onClick()}
        ></div>
      ))}
    </div>
  );
};
